import Swiper from 'swiper/bundle';

if ($(".slider-reviews.swiper-container").length > 0) {
    const slider_reviews_swiper = new Swiper(".slider-reviews.swiper-container", {
        slidesPerView: 'auto',
        loop: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".section-reviews-slider .swiper-button-next.slider-reviews-swiper-button",
            prevEl: ".section-reviews-slider .swiper-button-prev.slider-reviews-swiper-button",
        },
    });
}